import moment from 'moment';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
// TODO: Upgrade date picker to v2 - NWP-905
// valid support states
const STATES = ['', 'error', 'success'];

const arrayIncludes = (array, value) => array.indexOf(value) !== -1;

export default {
  name: 'MDatepicker',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: [String, Date],
      default: '',
    },
    mode: {
      type: String,
      default: 'single',
    },
    state: {
      type: String,
      default: '',
      validator: state => arrayIncludes(STATES, state),
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    date: '',
    options: {
      popover: { placement: 'bottom' },
    },
  }),
  computed: {
    localState() {
      return arrayIncludes(STATES, this.state) ? this.state : '';
    },
  },
  methods: {
    getDisplayClass() {
      if (this.localState === 'error') {
        return 'vc-text-base vc-text-red-600 vc-red-200 vc-border vc-border-red-500 vc-rounded vc-w-full vc-py-2 vc-px-3 placeholder-red-600';
      }
      if (this.localState === 'success') {
        return 'vc-text-base vc-text-green-500 vc-green-200 vc-border vc-border-green-500 vc-rounded vc-w-full vc-py-2 vc-px-3';
      }
      return 'vc-text-base vc-border vc-rounded vc-w-full vc-py-2 vc-px-3';
    },
  },
  watch: {
    date(value) {
      this.$emit('input', value || '');
    },
    value(value) {
      if (value === '') this.date = '';
    },
  },
  mounted() {
    if (this.value !== '' && !moment.isDate(this.value)) {
      const tempDate = new Date(this.value);
      tempDate.setHours(12);
      this.date = tempDate;
    } else {
      this.date = this.value;
    }
  },
};
